import { Component, createRef } from 'react';
import { compose } from 'redux'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom'
import withAuth from '../../components/withAuth';
import InterventionsFilters from '../../components/Interventions/Extranet/InterventionsFilters'
import { getCurrentFunctionName } from '../../performanceModeManager';
import InterventionsList from '../../components/Interventions/Extranet/InterventionsList';
import InterventionsCounters from '../../components/Interventions/Extranet/InterventionsCounters';
import { setFilteredAndSortedInterventions } from '../../redux/intervention/extranetInterventionActions';
import moment from "moment";
import { formatStatus, getColorFromStatusLabel } from '../../redux/intervention/extranetInterventionStatus';
import InterventionStatusIcon from '../../components/Interventions/Extranet/InterventionStatusIcon';
import { mobileAndTabletCheck } from '../../utils';
import { Checkbox } from '@mui/material';

class ExtranetInterventions extends Component {

    constructor(props) {
        super(props);

        if (!this.props.extranetInterventions.displayAsList || mobileAndTabletCheck()) {//Chargement déjà effectué par le composant table
            let filters = this.props.withoutFilters ? null : this.props.extranetInterventions;

            this.props.setFilteredAndSortedInterventions(filters, this.props.componentPark, this.props.affair,
                this.props.tableState, this.props.activeUser, this.props.sites.selectedSite, this.props.sites.sites, this.props.tableState.nbTotalResults);
        }

        this.table = createRef();
        this.state = {
            columns: [
                {
                    Header: "Date",
                    width: 150,
                    id: 'date_planned_start',
                    accessor: a => moment(a.date_planned_start).format("DD/MM/YYYY HH:mm"),
                },
                {
                    Header: "Numéro",
                    width: 80,
                    accessor: "name",
                },
                {
                    Header: "Description",
                    accessor: "failure_description",
                    minWidth: 120,
                    maxWidth: 600,
                    Cell: ({row}) => {
                        let currentIntervention = this.props.extranetInterventions.filteredAndSortedInterventions.filter((a) => !a.deleted)[row.index];
                        if (!currentIntervention)
                            return null;

                        return (
                            <div className="large-text-cell">
                                {currentIntervention.failure_description}
                            </div>
                        )
                    }
                },
                {
                    Header: "Type",
                    minWidth: 100,
                    maxWidth: 200,
                    accessor: "allocation_label",
                },
                {
                    Header: "Statut",
                    id: 'state',
                    accessor: (i) => formatStatus(i.state),
                    Cell: ({value}) => {
                        return (
                            <>
                                <InterventionStatusIcon state={value} />
                                <span className={"status-icon-color-" + getColorFromStatusLabel(value)} >
                                    {formatStatus(value)}
                                </span>
                            </>
                        )
                    },
                    minWidth: 100,
                    maxWidth: 200,
                },
                {
                    Header: "Cerfa",
                    minWidth: 100,
                    id: 'has_liquid_file',
                    maxWidth: 200,
                    accessor: i => i.has_liquid_file ? "Oui" : "Non",
                    Cell: ({row}) => {
                        let currentIntervention = this.props.extranetInterventions.filteredAndSortedInterventions.filter((a) => !a.deleted)[row.index];
                        if (!currentIntervention)
                            return null;

                        return (
                            <Checkbox checked={currentIntervention.has_liquid_file} className="div-center small-checkbox" onChange={this.props.onChange} />
                        )
                    }
                },
            ]
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.sites.selectedSite !== this.props.sites.selectedSite) {
            let filters = this.props.withoutFilters ? null : this.props.extranetInterventions;

            this.props.setFilteredAndSortedInterventions(filters, this.props.componentPark, this.props.affair,
                this.props.tableState, this.props.activeUser, this.props.sites.selectedSite, this.props.sites.sites, this.props.tableState.nbTotalResults);
        }
    }

    render() {
        console.perfLog(getCurrentFunctionName());

        return (
            <div className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding-only-small-screen">
                {!this.props.withoutFilters ? (
                    <InterventionsFilters interventionsFilters={this.props.extranetInterventions} {...this.props} />
                ) : null}
                <InterventionsCounters columns={this.state.columns} />
                <InterventionsList columns={this.state.columns} {...this.props} interventionsFilters={this.props.withoutFilters ? null : this.props.extranetInterventions}
                    plannedInterventions={this.props.extranetInterventions.filteredAndSortedInterventions} />
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        extranetInterventions: state.extranetInterventions,
        sites: state.sites,
        tableState: state.tableState
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setFilteredAndSortedInterventions: (interventionsFilters, componentPark, affair, tableState, user, customerSiteId, allSites, nbTotalResults) =>
            dispatch(setFilteredAndSortedInterventions(interventionsFilters, componentPark, affair, tableState, user, customerSiteId, allSites, nbTotalResults)),
    };
};

export default compose(withAuth, withRouter, connect(mapStateToProps, mapDispatchToProps))(ExtranetInterventions);
